export default __webpack_public_path__ + "static/media/198LafayetteStRendering.4e7f2833.png";